export const applyTailwindClasses = (html) => {
	// Crea un parser DOM
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, "text/html");

	// Aggiungi classi ai tag HTML
	doc.querySelectorAll("h1").forEach((el) => el.classList.add("text-4xl", "font-bold"));
	doc.querySelectorAll("h2").forEach((el) => el.classList.add("text-3xl", "font-bold"));
	doc.querySelectorAll("h3").forEach((el) => el.classList.add("text-2xl", "font-bold"));
	doc.querySelectorAll("blockquote").forEach((el) =>
		el.classList.add("pl-4", "border-l-4", "border-gray-400", "italic", "text-gray-600")
	);
	doc.querySelectorAll("ul").forEach((el) => el.classList.add("list-disc", "ml-8"));
	doc.querySelectorAll("ol").forEach((el) => el.classList.add("list-decimal", "ml-8"));
	doc.querySelectorAll("a").forEach((el) => el.classList.add("text-blue-500", "underline"));
	doc.querySelectorAll("img").forEach((el) => el.classList.add("rounded", "shadow-md", "my-4"));

	// Restituisci il contenuto HTML modificato
	return doc.body.innerHTML;
};
